<template>
    <div
        v-if="item.route"
        class="hts-menu__item">
        <hts-link
            class="hts-menu__item-container"
            :to="{ ...item.route, params: { id: workspaceId } }"
            :draggable="draggable"
            @dragstart="handleDragStart">
            <hts-icons
                :icon-name="item.icon"
                class="inline-block" />
            <div
                v-if="item.route"
                class="item-link">
                {{ item.name }}
            </div>
        </hts-link>
        <div
            v-if="item.children && Array.isArray(item.children) && item.children.length"
            class="hts-menu__item-child">
            <recursive-component
                v-for="(child, index) in item.children"
                :key="index"
                :item="child"
                :workspace-id="workspaceId" />
        </div>
    </div>
</template>
<script lang="ts" setup>
import RecursiveComponent from './menu-item.vue'

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  workspaceId: String,
  draggable: Boolean
})
const { item, workspaceId } = toRefs(props)
const handleDragStart = (e: any) => {}
</script>
